<template>
  <HeadlineComponent :subtitle="`Insgesamt: ${exports.length}`"
    >Badge Exporte für {{ event.name }}</HeadlineComponent
  >
  <button class="btn btn-primary mb-3" @click="refresh(true)">
    <i class="fa fa-refresh"></i> Aktualisieren
  </button>
  <div v-if="loadingExports">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <div v-if="!loadingExports">
    <template v-for="badge of exports" :key="badge.id">
      <div class="mb-4 row">
        <div
          class="col-2 align-self-center text-center"
          style="font-size: 32px"
        >
          <i v-if="!badge.done" class="fa fa-clock-o text-warning"></i>
          <i v-if="badge.done" class="fa fa-check text-success"></i>
        </div>
        <div class="row col-10">
          <div class="col-6 offset-2 offset-md-0 align-self-top">
            <span
              >Export gestartet: <br />
              {{
                $filters.formatDate(badge.created_at, "DD.MM.yyyy HH:mm")
              }}Uhr</span
            >
          </div>
          <div
            v-if="badge.done"
            class="mt-3 mt-md-0 col-6 col-md-6 offset-2 offset-md-0 align-self-top"
          >
            <span
              >Export fertig:<br />
              {{
                $filters.formatDate(badge.updated_at, "DD.MM.yyyy HH:mm")
              }}Uhr</span
            ><br />
            {{ badge.total }} Badges
            <a
              v-if="badge.total"
              :href="`/api/event/${event.id}/badge/${badge.id}/download`"
              >Download</a
            >
          </div>
        </div>
      </div>
      <hr class="mb-4 volunteer-hr" />
    </template>
  </div>
  <h2>Neuen Export anlegen</h2>
  <Form class="form-horizontal" @submit="create">
    <div class="form-group">
      <div class="form-check">
        <Field
          type="checkbox"
          class="form-check-input"
          id="export_all"
          :value="true"
          name="export_all"
        />
        <label class="form-check-label" for="export_all">
          Alle alten Exporte löschen und alle Badges neu exportieren
        </label>
      </div>
    </div>
    <div class="form-group">
      <LoadingButton class="btn-primary" :loading="loading"
        >Neuen Export generieren</LoadingButton
      >
    </div>
  </Form>
</template>

<script>
import { mapActions } from "pinia";
import { useAlertsStore } from "@/stores/alerts.js";
import HeadlineComponent from "@/components/HeadlineComponent.vue";
import eventService from "@/services/event.service";
import LoadingButton from "@/components/LoadingButton.vue";
import { Form, Field } from "vee-validate";
import * as Sentry from '@sentry/vue';

export default {
  name: "EventsView",
  // eslint-disable-next-line vue/no-reserved-component-names
  components: { HeadlineComponent, LoadingButton, Form, Field },
  data() {
    return {
      event: {},
      exports: [],
      loadingExports: false,
      loading: false,
    };
  },
  async beforeMount() {
    try {
      let response = await eventService.get(this.$route.params.event);
      this.event = response.data;
    } catch (e) {
      if (e) {
        Sentry.captureException(e);
        this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
        window.scrollTo(0, 0);
      }
    }
    this.refresh();
  },
  methods: {
    ...mapActions(useAlertsStore, { addAlert: "add" }),
    async refresh(fake) {
      this.loadingExports = true;
      if (fake) {
        this.exports = [];
        const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
        await sleep(100);
      }
      try {
        let response = await eventService.getBadgeExports(
          this.$route.params.event
        );
        this.exports = response.data;
      } catch (e) {
        if (e) {
          Sentry.captureException(e);
          this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
      }
      this.loadingExports = false;
    },
    async create(values) {
      this.loading = true;
      try {
        let response = await eventService.createBadgeExport(
          this.event.id,
          values
        );
        if (values.export_all) {
          this.exports = [];
        }
        this.exports.push(response.data);
        this.addAlert(
          "success",
          "Der Badge Export wurde angefordert, du wirst per Mail benachrichtigt sobald er verfügbar ist."
        );
      } catch (e) {
        if (e) {
          Sentry.captureException(e);
          this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
